// extracted by mini-css-extract-plugin
export default {"purchaseContainer":"submit-purchase_purchaseContainer__olrEQ","header":"submit-purchase_header__fbdPS","content":"submit-purchase_content__U-QLj"};